import React, {useEffect, useLayoutEffect} from "react";
import styled from "styled-components";
import PullToRefresh from "react-simple-pull-to-refresh";

import {useParams, useNavigate, useNavigationType} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {
	fetchDetailPageScroll,
	fetchDetailSummaryInfo,
	updateDailySummaryInfo,
	updateWeeklySummaryInfo,
	updateMonthlySummaryInfo,
	updateOrderPaymentList,
} from "redux/slices/sales/salesSlice";

import {getCalendar} from "utils/date";
import {getDetailTitle} from "utils/define";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "./SummaryInfo";
import DetailList from "./DetailList";
import BottomBranch from "components/ui/popup/BottomBranch";
import PullToRefreshing from "components/common/PullToRefreshing";



/**
 * [기간별 매출]
 */

export const Detail = ({mode}) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();
	const {seqPartnerBranch} = useParams();

	let {
		searchPartner,
		searchBranch,
		searchDate,
		searchPeriodType,
		data,
		isLoading,
		isError
	} = useSelector(state => state.sales.detailSummaryInfo);
	const partnerInfo = useSelector(state => state.partner);
	const salesInfo = useSelector(state => state.sales);

	useEffect(() => {
		if(!searchPartner || (navigationType != "POP" && (searchPartner != partnerInfo.seqPartner || searchBranch != partnerInfo.seqPartnerBranch || searchPeriodType != salesInfo.searchPeriodType))) {
			searchPartner = partnerInfo.seqPartner;
			searchBranch = Number(seqPartnerBranch) || partnerInfo.seqPartnerBranch;
			searchDate = salesInfo.searchDate;
			searchPeriodType = salesInfo.searchPeriodType;
			dispatch(fetchDetailSummaryInfo({
				searchPartner : searchPartner,
				searchBranch : searchBranch,
				searchDate : searchDate,
				searchPeriodType : searchPeriodType
			}));
		}
	}, []);

	useLayoutEffect(() => {
		return () => {
			dispatch(fetchDetailPageScroll("store"));
		};
	}, []);

	useEffect(() => {
		const isUpdate = (
			!data || navigationType != "POP" || (
				searchPartner != data.searchInfo.searchPartner ||
				searchBranch != data.searchInfo.searchBranch ||
				searchDate != data.searchInfo.searchDate ||
				searchPeriodType != data.searchInfo.searchPeriodType
			)
		);
		if(isUpdate) eventHandler.update();
	}, [searchPartner, searchBranch, searchDate, searchPeriodType]);

	const eventHandler = {
		update : () => {
			let updateAction, searchCount ;
			switch(mode) {
				case "daily" : updateAction = updateDailySummaryInfo; searchCount = 1; break;
				case "weekly" : updateAction = updateWeeklySummaryInfo; break;
				case "monthly" : updateAction = updateMonthlySummaryInfo; break;
			}
			dispatch(updateAction({
				searchPartner : searchPartner,
				searchBranch : searchBranch,
				searchDate : searchDate,
				searchCount : searchCount
			}, fetchDetailSummaryInfo, "detailSummaryInfo"));
		},
		changeDate : (date) => {
			dispatch(fetchDetailSummaryInfo({
				searchDate : date
			}));
		},
		changeBranch : (branch) => {
			dispatch(fetchDetailSummaryInfo({
				searchBranch : branch,
			}));
		},
		pullToRefresh: () => {
			return new Promise((resolve) => {
				setTimeout(() => {
					eventHandler.update();
					dispatch(updateOrderPaymentList(false));
					resolve();
				}, 700);
			});
		}
	};

	const render = () => {
		const getTitle = () => {
			const suffix = ((mode == "daily") ? "일간" : (mode == "weekly") ? "주간" : (mode == "monthly") ? "월간" : "") + " 매출";
			return getDetailTitle(partnerInfo, searchPartner, searchBranch, suffix);
		}
		const isChart = (mode != "daily");
		return (
			<PullToRefresh
				onRefresh={eventHandler.pullToRefresh}
				resistance={2}
				pullingContent={<></>}
				refreshingContent={<PullToRefreshing />}
			>
				<MainLayout
					withHeader={true}
					headerProps={{
						withBackButton : true,
						centerTitle : getTitle()
					}}
					backgroundColor="white"
					withBottomTab={false}
				>
					<SummaryInfo
						mode={mode}
						date={searchDate}
						data={data}
						isChart={isChart}
						isLoading={isLoading}
						isError={isError}
						onChange={eventHandler.changeDate}
						onRefresh={eventHandler.update}
					/>
					<DetailList />
					<BottomBranch searchBranch={searchBranch} onChange={eventHandler.changeBranch} />
				</MainLayout>
			</PullToRefresh>
		);
	};
	return render();
};

export default Detail;